import React from 'react'
import styled from 'styled-components'

import { COLORS } from '~/common/globalStyles'

import BrandLogo from './BrandLogo'
import IconLogo from './IconLogo'

const Svg = styled.svg(
  ({ height, width }) => `
  height: ${height ? `${height}px` : 'auto'};
  width: ${width ? `${width}px` : 'auto'};
`,
)

interface LogoProps {
  fill?: keyof typeof COLORS
  height?: string
  width?: string
  variant?: 'complete' | 'icon'
  iconFill?: keyof typeof COLORS
}

const LogoMap = {
  complete: BrandLogo,
  icon: IconLogo,
}

const Logo: React.FC<LogoProps> = ({
  fill = 'black',
  height,
  variant = 'complete',
  width,
}) => {
  const CurrentLogo = LogoMap[variant]

  return <CurrentLogo Svg={Svg} width={width} height={height} fill={fill} />
}

export default Logo
